export default "__VITE_ASSET__Bl0jeFHB__"